import React from "react";
import PropTypes from "prop-types";
import useNotifier from "@/hooks/useNotifier";
import { OverlayProvider } from "@/components/overlays";
import { Loading } from "@/components/loading/loading";
import useLoanApplicationParameters from "@/modules/client/loan-application/hooks/use-loan-application-parameters";

/**
 * ClientLoanOriginationLayout — clean full-height centered layout for the loan
 * application wizard. The wizard card now owns its own branded header so the old
 * indigo hero + topbar have been removed.
 *
 * Loads the scoped parameter set (countries, loanTypes, loanStatuses,
 * propertyTypes, propertyUses) via RTK Query before rendering children.
 */
export default function ClientLoanOriginationLayout({ children }) {
  useNotifier();
  const { isReady, isLoading } = useLoanApplicationParameters();

  if (isLoading || !isReady) return <Loading transparent={false} />;

  return (
    <OverlayProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-gradient-to-br from-slate-100 to-slate-200 p-4 sm:p-6 dark:from-slate-950 dark:to-slate-900">
        {children}
      </div>
    </OverlayProvider>
  );
}

ClientLoanOriginationLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
